document.addEventListener("DOMContentLoaded", function () {
  var firbCon = document.getElementById("firb-con");
  if (firbCon && firbCon.dataset.basecon !== undefined) {
    var firebaseConfig = JSON.parse(window.atob(firbCon.dataset.basecon));
    // Initialize Firebase
    firebase.initializeApp(firebaseConfig);
    var hp_initState = true;
    var hp_new_initState = true;

    var database = firebase.database();
    var path = window.location.pathname;

    if (path === "/new") {
      var hpNewRef = database.ref("hp_new_refresh/deals");

      hpNewRef.limitToLast(1).on("child_added", function (snapshot) {
        if (hp_initState) {
          hp_initState = false;
        } else {
          var btnAutoRefresh = document.getElementById("btn-auto-refresh");
          if (btnAutoRefresh) btnAutoRefresh.style.display = "flex";
        }
      });
    } else if (path === "/") {
      var hpRef = database.ref("hp_refresh/deals");
      var hpNewRef = database.ref("hp_new_refresh/deals");

      hpRef.limitToLast(1).on("child_added", function (snapshot) {
        if (hp_initState) {
          hp_initState = false;
        } else {
          var btnAutoRefresh = document.getElementById("btn-auto-refresh");
          if (btnAutoRefresh) btnAutoRefresh.style.display = "flex";
        }
      });

      hpNewRef.limitToLast(1).on("child_added", function (snapshot) {
        if (hp_new_initState) {
          hp_new_initState = false;
        } else {
          var newDealCounter = document.getElementById("new-deal-counter");
          if (newDealCounter) {
            var x = newDealCounter.textContent.trim();
            var y = x ? parseInt(x, 10) + 1 : 1;
            newDealCounter.innerHTML = `<span class="deal-counter ml-2 text-sm min-w-max h-5 inline-flex px-2 bg-highlight-red justify-center items-center rounded-full text-white hover:text-white">${y}</span>`;
          }
        }
      });
    } else if (path === "/discussed") {
      var hpNewRef = database.ref("hp_new_refresh/deals");

      hpNewRef.limitToLast(1).on("child_added", function (snapshot) {
        if (hp_new_initState) {
          hp_new_initState = false;
        } else {
          var newDealCounter = document.getElementById("new-deal-counter");
          if (newDealCounter) {
            var x = newDealCounter.textContent.trim();
            var y = x ? parseInt(x, 10) + 1 : 1;
            newDealCounter.innerHTML = `<i class="deal-counter">${y}</i>`;
          }
        }
      });
    }
  }
});

document.getElementById("btn-auto-refresh")?.addEventListener("click", function () {
  window.location.reload();
});